// функция скролла
export default function scrollIt(
    destination,
    duration = 200,
    easing = 'linear',
    callback = undefined
) {
    const easings = {
        linear(t) {
            return t;
        },
        easeInQuad(t) {
            return t * t;
        },
        easeOutQuad(t) {
            return t * (2 - t);
        },
        easeInOutQuad(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic(t) {
            return t * t * t;
        },
        easeInOutCubic(t) {
            return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart(t) {
            return t * t * t * t;
        },
        easeInQuint(t) {
            return t * t * t * t * t;
        }
    };

    // Определение координаты элемента по вертикали от начала документа
    function pageY(elem) {
        return elem.offsetParent
            ? elem.offsetTop + pageY(elem.offsetParent)
            : elem.offsetTop;
    }

    const start = window.pageYOffset;
    const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

    const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
    );
    const windowHeight = window.innerHeight
        || document.documentElement.clientHeight
        || document.getElementsByTagName('body')[0].clientHeight;

    const destinationOffset = typeof destination === 'number' ? destination : pageY(destination);

    let menuHeight = 0;
    if (document.getElementById('header-nav')) menuHeight = document.querySelector('.menu__header').offsetHeight;

    const destinationOffsetToScroll = Math.round(
        documentHeight - destinationOffset - menuHeight < windowHeight ? documentHeight - windowHeight - menuHeight : destinationOffset - menuHeight
    );

    if ('requestAnimationFrame' in window === false) {
        window.scroll(0, destinationOffsetToScroll);
        if (callback) {
            callback();
        }
        return;
    }

    function scroll() {
        const now = 'now' in window.performance ? performance.now() : new Date().getTime();
        const time = Math.min(1, (now - startTime) / duration);
        const timeFunction = easings[easing](time);
        // эта функция скролит по чуть чуть
        window.scroll(
            0,
            Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start)
        );
        // усоловие если время истекло, то поставь в конечную точку анимации
        if (duration <= now - startTime) {
            return;
        }
        // это условие проверяет условие кончилась ли аницация.
        // в данном случае проверяет дошли ли до точки назначения
        if (window.pageYOffset === destinationOffsetToScroll) {
            if (callback) {
                callback();
            }
            return;
        }
        // эта функция запускает следующую итерацию анимации
        requestAnimationFrame(scroll);
    }

    scroll();
}
